import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { en, fr } from "./locales";

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translations: en,
      },
      "en-US": {
        translations: en,
      },
      "en-GB": {
        translations: en,
      },
      fr: {
        translations: fr,
      },
    },
    // No explicit `lng`: the LanguageDetector reads the persisted choice from
    // localStorage so the selected language survives reloads. First-time users
    // (no stored value) fall back to French.
    fallbackLng: "fr",
    debug: false,
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },

    // Translation keys are full phrases that contain "." and ":" (e.g.
    // "Loading...", "ex: +33612345678"). Disable key/namespace separators so the
    // whole string is treated as a single literal key.
    keySeparator: false,
    nsSeparator: false,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
